/* eslint-disable jsx-a11y/anchor-is-valid */
import { Button, TextLink } from '@dsg-tech/homefield-react';
import { HomefieldIconPrivacyOptions } from '@dsg-tech/homefield-react-icons';
import { checkStores, openSurveyLink, setDataEmTag } from 'utility/utility';
import { CTA, StoreIdentifierName } from 'types';
import './BottomFooterLinks.scss';

interface Props {
  storeIdentifierName: StoreIdentifierName;
  bottomFooterLinksData: CTA[];
}

export default function BottomFooterLinks({
  bottomFooterLinksData,
  storeIdentifierName,
}: Readonly<Props>) {
  const contactNumber = storeIdentifierName === 'pl' ? '1-844-890-0896' : '1-877-846-9997';
  return (
    <div data-testid="BottomFooterLinks" className="bottomFooterLinks-container hmf-py-m">
      <div className="bottomFooterLinks-container__content-wrapper hmf-px-s">
        <p className="bottomFooterLinks-container__copyright hmf-body-s">
          © {new Date().getFullYear()} {storeIdentifierName === 'pl' ? 'Public Lands' : 'Moosejaw'}
        </p>
        <div className="bottomFooterLinks-container__links-wrapper hmf-mb-xxs hmf-display-flex">
          {bottomFooterLinksData
            .filter((links: any) => links.linkTitle !== 'Site Feedback')
            .map((links: any) => {
              return (
                <span
                  data-testid="BottomFooterLinks-link"
                  key={links.linkTitle}
                  className="bottomFooterLinks-container__links-wrapper--links">
                  <TextLink
                    variant="group"
                    size="small"
                    href={checkStores(links.link)}
                    data-em={setDataEmTag('Footer', links.linkTitle)}>
                    <>{links.linkTitle}</>
                  </TextLink>
                  {links.linkTitle === 'Your Privacy Choices' && (
                    /* Add homefield icon once icon is available in homefield */
                    <HomefieldIconPrivacyOptions
                      data-testid="BottomFooterLinks-privacy-icon"
                      height="28"
                      width="28"
                      className="hmf-pl-xxxs"
                    />
                  )}
                </span>
              );
            })}
        </div>
        <div className="bottomFooterLinks-container__feedback-row hmf-display-flex hmf-flex-row hmf-justify-content-between hmf-align-items-flex-end">
          <div>
            <p className="bottomFooterLinks-container__feedback-row__disclaimer-text hmf-body-s">
              If you are using a screen reader or other assistive technology and are having problems
              using this website, or if you have any other difficulties accessing this website,
              please call{' '}
              <TextLink variant="tertiary" size="small" href={`tel:${contactNumber}`}>
                {contactNumber}
              </TextLink>{' '}
              for assistance
            </p>
            {storeIdentifierName === 'pl' && (
              <p
                data-testid="BottomFooterLinks-pl-donations-legal-disclaimer"
                className="bottomFooterLinks-container__feedback-row__disclaimer-text hmf-body-s">
                *Donations are based on purchase price, excluding taxes or other charges. The Public
                Lands Fund is a program of the DICK’S Sporting Goods Foundation, a 501(c)(3)
                charity. Learn more at{' '}
                <TextLink
                  variant="tertiary"
                  size="small"
                  href="https://www.publiclandsfund.org/"
                  rel="noopener noreferrer"
                  target="_blank">
                  publiclandsfund.org
                </TextLink>
                .
              </p>
            )}
          </div>

          {bottomFooterLinksData
            .filter((links: any) => links.linkTitle === 'Site Feedback')
            .map((link: any) => {
              return (
                <div key={link.linkTitle} data-testid="BottomFooterLinks-survey-button">
                  <Button
                    size="small"
                    variant="primary"
                    text={link.linkTitle}
                    data-em={setDataEmTag('Footer', link.linkTitle)}
                    onClick={() => {
                      openSurveyLink(link.link);
                    }}
                  />
                </div>
              );
            })}
        </div>
      </div>
    </div>
  );
}
